
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Brand = () => {
  return (
    <SettingsMetaData propertyName={"brand_item"} viewPropertyName={"Brand"} />
  );
};
export default Brand;
